import { routePaths, type RoutePath } from '@config/routes'

const REGISTERED_ROUTE_PATHS = Object.values(routePaths).filter(
  (path) => path !== routePaths.login,
) as RoutePath[]

/** Known legacy im_aspx_name values that differ from SPA route paths. */
const LEGACY_MENU_ALIASES: Record<string, RoutePath> = {
  '/isinhistory': routePaths.isinHistories,
  '/findyourshareholder': routePaths.findYourShareHolder,
}

/** Normalize legacy WebForms menu paths (im_aspx_name) to SPA routes. */
export function normalizeLegacyMenuPath(pageName: string): string {
  let trimmed = pageName.trim()
  if (!trimmed || trimmed === '#') {
    return '#'
  }

  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://')
  ) {
    return trimmed
  }

  trimmed = trimmed.replace(/^~+/, '')

  const queryIndex = trimmed.indexOf('?')
  if (queryIndex >= 0) {
    trimmed = trimmed.slice(0, queryIndex)
  }

  trimmed = trimmed.replace(/\\/g, '/')
  trimmed = trimmed.replace(/\/+$/, '')
  trimmed = trimmed.replace(/\.aspx$/i, '')

  if (!trimmed.startsWith('/')) {
    trimmed = `/${trimmed}`
  }

  const lower = trimmed.toLowerCase()
  const alias = LEGACY_MENU_ALIASES[lower]
  if (alias) {
    return alias
  }

  const matched = REGISTERED_ROUTE_PATHS.find(
    (path) => path.toLowerCase() === lower,
  )

  return matched ?? trimmed
}

export function normalizeRoutePath(path: string): string {
  const trimmed = path.trim().replace(/\/+$/, '').toLowerCase()
  return trimmed || '/'
}
